// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YlBDp","type":"styles_type__18a6t","choices":"styles_choices__3AAE-"};